"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedAnalytics = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var chart_1 = __importDefault(require("./components/chart"));
var filter_1 = require("./components/filter");
function AdvancedAnalytics() {
    var _a;
    var divRef = (0, react_1.useRef)(null);
    var client = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).client;
    var initialFilter = { client_id: client === null || client === void 0 ? void 0 : client._id };
    var _b = (0, react_1.useState)(initialFilter), defaultFilter = _b[0], setDefaultFilter = _b[1];
    var _c = (0, react_1.useState)(initialFilter), filter = _c[0], setFilter = _c[1];
    var handleFilter = function (newFilter) {
        var createdAt = newFilter.createdAt;
        setDefaultFilter(__assign(__assign({}, defaultFilter), (createdAt && { createdAt: createdAt })));
        setFilter(__assign(__assign({}, filter), newFilter));
    };
    var chartIds = ((_a = process.env.MONGO_CHARTS_IDS) === null || _a === void 0 ? void 0 : _a.split(",")) || [];
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ ref: divRef, className: "grid grid-cols-1 gap-2 my-4" }, { children: [(0, jsx_runtime_1.jsx)(filter_1.Filters, { onSubmit: handleFilter }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "grid grid-cols-3 gap-2" }, { children: chartIds.slice(0, 3).map(function (chartId, index) { return ((0, jsx_runtime_1.jsx)(chart_1.default, { filter: defaultFilter, chartId: chartId, height: 150 }, index)); }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "grid grid-cols-3 gap-2" }, { children: chartIds.slice(3, 6).map(function (chartId, index) { return ((0, jsx_runtime_1.jsx)(chart_1.default, { filter: filter, chartId: chartId, height: 150 }, index)); }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "grid grid-cols-2 gap-2" }, { children: chartIds.slice(6).map(function (chartId, index) { return ((0, jsx_runtime_1.jsx)(chart_1.default, { filter: filter, chartId: chartId, height: 400 }, index)); }) }))] })));
}
exports.AdvancedAnalytics = AdvancedAnalytics;
